import { defineMessages } from "react-intl";

const baseId = "t.pages.ReportStepTwo.";

export default defineMessages({
    ReportPanelTitle: {
        id: baseId + "ReportPanelTitle",
        defaultMessage: "Detail",
    },
    CTABack: {
        id: baseId + "CTABack",
        defaultMessage: "Back to Home",
    },
    Generate: {
        id: baseId + "Generate",
        defaultMessage: "Generate",
    },
    //DETAIL PANEL
    PanelDetailRequestLabelID: {
        id: baseId + "PanelDetailRequestLabelID",
        defaultMessage: "Id",
    },
    PanelDetailRequestLabelName: {
        id: baseId + "PanelDetailRequestLabelName",
        defaultMessage: "Name",
    },
    PanelDetailRequestLabelDescription: {
        id: baseId + "PanelDetailRequestLabelDescription",
        defaultMessage: "Description",
    },
    CTA_CANCEL: {
        id: baseId + "CTA_CANCEL",
        defaultMessage: "Cancel",
    },

});
